import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.postit-polaroids';

/**
 * Predefined color combinations for post-it notes
 */
const POSTIT_COLORS = {
  blue: {
    background: '#D2E4FF',
    text: '#1A427D',
  },
  yellow: {
    background: '#FFF7E3',
    text: '#9E3D00',
  },
  green: {
    background: '#E4F7E1',
    text: '#2E6B2D',
  },
  pink: {
    background: '#FFE6EF',
    text: '#A0154B',
  },
  purple: {
    background: '#F0E6FF',
    text: '#4A1A7D',
  },
};

/**
 * Get color combination for post-it note
 * @param {string} color - Color name (blue, yellow, green, pink, purple)
 * @returns {Object} Object containing background and text colors
 */
const getPostitColors = (color) => POSTIT_COLORS[color] || POSTIT_COLORS.yellow;

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      const slider = document.createElement('div');
      slider.classList.add('splide');
      const sliderTrack = document.createElement('div');
      sliderTrack.classList.add('splide__track');
      const sliderList = document.createElement('div');
      sliderList.classList.add('splide__list');

      data.forEach((item) => {
        const sliderItem = document.createElement('div');
        sliderItem.classList.add('splide__slide');

        // Generate a random angle between 1.2 and 5, randomly positive or negative
        const min = 1.2;
        const max = 5;
        const angle = (Math.random() * (max - min) + min).toFixed(2);
        const rotation = Math.random() < 0.5 ? -angle : angle;
        sliderItem.style.transform = `rotate(${rotation}deg)`;

        let slideContent = '';
        const colors = getPostitColors(item.color);

        switch (item.type) {
        case 'postit':
          slideContent = `
              <div class="postit" style="background-color: ${colors.background}">
                <h3 style="color: ${colors.text}">${item.title}</h3>
                <p style="color: ${colors.text}">${item.text}</p>
              </div>
            `;
          break;
        case 'polaroid':
          slideContent = `
              <div class="polaroid">
                <img src="${item.image}" alt="${item.title}" />
                <h3>${item.title}</h3>
              </div>
            `;
          break;
        default:
          slideContent = `
              <div class="postit" style="background-color: ${colors.background}">
                <h3 style="color: ${colors.text}">${item.title}</h3>
                <p style="color: ${colors.text}">${item.text}</p>
              </div>
            `;
        }
        sliderItem.innerHTML = slideContent;
        sliderList.appendChild(sliderItem);
      });

      sliderTrack.appendChild(sliderList);
      slider.appendChild(sliderTrack);
      query.appendChild(slider);

      const splide = new Splide(slider, {
        type: 'slide',
        perPage: 6,
        perMove: 1,
        arrows: false,
        pagination: false,
        breakpoints: {
          1330: {
            perPage: 4,
          },
          992: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          500: {
            perPage: 1,
          },
        },
      });

      splide.mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
